import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#55acba" }, [
      _createElementVNode("path", { d: "M9.62 15.56c7 0 9-2 9-3v-2c-2 1-5 2-9 2-4.2 0-7.2-1-9-2v2c0 1 2.2 3 9 3zm0-5c7 0 9-2.2 9-3v-2c-2 1.2-5 2-9 2-4.2 0-7.2-.8-9-2v2c0 .8 2.2 3 9 3zm0-5c5 0 8-1.3 9-2.3-2-1.76-5-2.7-9-2.7-3.7 0-7.4.94-8.6 2.7.9 1 3.4 2.3 8.6 2.3zm5 11c-1 1-3 1-5 1-4.2 0-7.2-1-9-2v1c0 3 4.5 4 9 4h4c0-2 1-3 1-4z" }),
      _createElementVNode("ellipse", {
        cx: "18",
        cy: "17",
        rx: "4.7",
        ry: "5.5",
        fill: "#fff"
      })
    ], -1),
    _createElementVNode("path", {
      d: "M12 36c0 9 7 16 16 16s17-7 17-16c0-1-1-8-5-12l7-7c4 4 9 14 6 25-1 9-10 20-24 20C14 62 2.2 51 1.7 36 1.3 23 10 12 22 9.5V2l17 10-17 17v-9c-7 2-11 8-10 16z",
      transform: "matrix(.13 -.2 -.19 -.13 20.8 27.48)",
      fill: "#55acba",
      stroke: "#fff",
      "stroke-width": "3"
    }, null, -1)
  ])))
}
export default { render: render }